import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { myHomePageLayout } from '../../components/home/HomePage';

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [myHomePageLayout],
});
